import "./Button.scss";

import React from "react";

import { observable, action } from "mobx";
import { observer } from "mobx-react";

@observer
class Button extends React.Component {
  constructor(props) {
    super(props);
    this.ref = React.createRef();
  }

  componentDidMount = () => {
    if (this.props.focus)
      this.ref &&
        this.ref.current.scrollIntoView({
          //behavior: 'smooth',
          //block: 'start',
        });
  };

  @observable isActive = false;
  clickHandler = () => {};

  @observable isMoved = false;

  @action
  onMouseDown = () => {
    this.isActive = true;
  };

  @action
  onMouseUp = () => {
    this.isActive = false;
  };

  @action
  onMouseMove = () => {
    this.isActive = false;
  };

  render() {
    const { props } = this;

    const classNames = ["btn"];
    if (props.modifiers) {
      props.modifiers.forEach((modifier) => {
        if (!modifier) return;
        classNames.push("btn" + "--" + modifier);
      });
    }
    if (props.disabled) classNames.push("btn--disabled");
    if (props.className) classNames.push(props.className);

    //if (!props.disabled) this.clickHandler = props.onClick
    //if (!props.listElement) delete props.onClick

    if (!props.disabled && this.isActive) {
      classNames.push("btn--pressed");
    }

    const newProps = { ...props };
    newProps.className = classNames.join(" ");

    if (props.disabled) delete newProps.onClick;

    return (
      <div
        onMouseDown={this.onMouseDown}
        onMouseUp={this.onMouseUp}
        onMouseMove={this.onMouseMove}
        //onClick={this.clickHandler}
        ref={this.ref}
        {...newProps}
      >
        {props.children}
      </div>
    );
  }
}

export default Button;
